// import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import './AdvaceOtions.style.scss';
import React from "react";
import arrowdown from "../../assets/arrowdown.svg";
import RangeSlider from 'Component/RangeSlider/RangeSlider.component';
import { generateQuery, getQueryParam } from '@scandipwa/scandipwa/src/util/Url';
import history from '@scandipwa/scandipwa/src/util/History';
import Link from '@scandipwa/scandipwa/src/component/Link';

export class AdvaceOtions extends PureComponent {
    static propTypes = {
        renderGetDiamond: this.propTypes,
        isMobile: this.propTypes
    };

    constructor(props) {
        super(props);
        this.state = {
            advanceoption_open: false,
            showoptions: false,
            attribute_code: "",
            cutminvalue: 0,
            cutmaxvalue: 4,
            cutlabels: ["good", "very good", "excellent", "ideal", ""],
            polishminvalue: 0,
            polishmaxvalue: 3,
            polishlabels: ["good", "very good", "excellent", ""],
            symmetryminvalue: 0,
            symmetrymaxvalue: 3,
            symmetrylabels: ["good", "very good", "excellent", ""],
            fluorescenceminvalue: 0,
            fluorescencemaxvalue: 4,
            fluorescencelabels: ["strong", "medium", "faint", "none", ""],
            depthminvalue: 0,
            depthmaxvalue: 100,
            depthFilterminvalue: 0,
            depthFiltermaxvalue: 100,
            tableminvalue: 0,
            tablemaxvalue: 100,
            tableFilterminvalue: 0,
            tableFiltermaxvalue: 100,
            diamond_created_from: "",
            changevalue: false,
            changetablevalue: false
        }
    }

    componentDidMount() {
        const location = window?.location;
        // cut filter
        const cutfilter = getQueryParam("diamond_cut", location || '');

        if (cutfilter) {
            const { cutlabels } = this.state;
            const filtervalue = cutfilter.split(",");

            this.setState({
                cutminvalue: cutlabels.indexOf(filtervalue[0]),
                cutmaxvalue: cutlabels.indexOf(filtervalue[filtervalue?.length - 1]) + 1
            })
        }

        // polisg filter
        const polishfilter = getQueryParam("diamond_polish", location || '');

        if (polishfilter) {
            const { polishlabels } = this.state;
            const polishfiltervalue = polishfilter.split(",");

            this.setState({
                polishminvalue: polishlabels.indexOf(polishfiltervalue[0]),
                polishmaxvalue: polishlabels.indexOf(polishfiltervalue[polishfiltervalue?.length - 1]) + 1
            })
        }

        // symmetry filter
        const symmetryfilter = getQueryParam("diamond_symmetry", location || '');

        if (symmetryfilter) {
            const { symmetrylabels } = this.state;
            const symmetryfiltervalue = symmetryfilter.split(",");

            this.setState({
                symmetryminvalue: symmetrylabels.indexOf(symmetryfiltervalue[0]),
                symmetrymaxvalue: symmetrylabels.indexOf(symmetryfiltervalue[symmetryfiltervalue?.length - 1]) + 1
            })
        }

        // fluorescence filter
        const fluorescencefilter = getQueryParam("diamond_fluorescence", location || '');

        if (fluorescencefilter) {
            const { fluorescencelabels } = this.state;
            const fluorescencefiltervalue = fluorescencefilter.split(",");

            this.setState({
                fluorescenceminvalue: fluorescencelabels.indexOf(fluorescencefiltervalue[0]),
                fluorescencemaxvalue: fluorescencelabels.indexOf(fluorescencefiltervalue[fluorescencefiltervalue?.length - 1]) + 1
            })
        }

        // depth filter
        const depthfilter = getQueryParam("depth", location || '');

        if (depthfilter) {
            const depthfiltervalue = depthfilter.split("_");

            this.setState({
                depthminvalue: depthfiltervalue[0],
                depthmaxvalue: depthfiltervalue[1],
                depthFilterminvalue: depthfiltervalue[0],
                depthFiltermaxvalue: depthfiltervalue[1]
            })
        }

        // table filter
        const tablefilter = getQueryParam("table", location || '');

        if (tablefilter) {
            const tablefiltervalue = tablefilter.split("_");

            this.setState({
                tableminvalue: tablefiltervalue[0],
                tablemaxvalue: tablefiltervalue[1],
                tableFilterminvalue: tablefiltervalue[0],
                tableFiltermaxvalue: tablefiltervalue[1]
            })
        }

        // diamond_created_from
        const diamond_created_from = getQueryParam("diamond_created_from", location || '');

        if (diamond_created_from) {
            this.setState({
                diamond_created_from: diamond_created_from
            });
        } else {
            if (window.location?.pathname?.includes("lab-grown-diamond")) {
                history.push(`${generateQuery({ diamond_created_from: "12" }, window.location, history)}`);
                this.setState({
                    diamond_created_from: "12"
                });
            } else if (window.location?.pathname?.includes("natural-diamond")) {
                history.push(`${generateQuery({ diamond_created_from: "11" }, window.location, history)}`);
                this.setState({
                    diamond_created_from: "11"
                });
            } else {
                // history.push(`${generateQuery({ diamond_created_from: "11" }, window.location, history)}`);
                // this.setState({
                //     diamond_created_from: "11"
                // });
            }
        }
    }

    renderHandleOpen = () => {
        this.setState({
            advanceoption_open: !this.state.advanceoption_open
        });
    }

    // cut filter
    handleChangeCutOptions(e) {
        const { cutlabels } = this.state;
        const diamond_cut = cutlabels.slice(e.minValue, e.maxValue);
        const { renderGetDiamond } = this.props;

        const query = generateQuery({ diamond_cut: `${diamond_cut}` }, window.location, history);
        this.setState({
            cutminvalue: e.minValue,
            cutmaxvalue: e.maxValue
        });
        history.push(query);
        renderGetDiamond();
    }

    renderCut() {
        const { cutlabels, cutmaxvalue, cutminvalue } = this.state;
        const { isMobile } = this.props;

        return (
            <>
                <div className='advace-options-swatchlist'>
                    {
                        isMobile ? <></> : <div
                            className='advanceoption-swatchlist-heading'
                            onClick={() => this.setState({
                                showoptions: this.state.attribute_code === "cut" ? !this.state.showoptions : true,
                                attribute_code: "cut"
                            })}
                        >
                            <span>Cut</span>
                            <img
                                className={this.state.attribute_code === "cut" && this.state.showoptions ? "open" : ""}
                                src={arrowdown}
                            />
                        </div>
                    }

                    {
                        (this.state.attribute_code === "cut" && this.state.showoptions) || isMobile ? <div className='advaceoptions-exapndable-options'>
                            <div className={"filteroption-title"}>
                                <span>Cut</span>
                                {!isMobile && <svg onClick={() => this.setState({
                                    showoptions: this.state.attribute_code === "cut" ? !this.state.showoptions : true,
                                    attribute_code: "cut"
                                })}
                                    xmlns="http://www.w3.org/2000/svg" height="16" width="12" viewBox="0 0 384 512" fill="#000000">
                                    <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                                </svg>}
                            </div>
                            <RangeSlider
                                label={true}
                                min={0}
                                max={4}
                                step={1}
                                labels={cutlabels}
                                minValue={cutminvalue}
                                maxValue={cutmaxvalue}
                                className={"colorrangeslider"}
                                onChange={(e) => this.handleChangeCutOptions(e)}
                            />
                        </div> : ""
                    }
                </div>
            </>
        );
    }

    // polish filter
    handleChangePolishOptions(e) {
        const { polishlabels } = this.state;
        const diamond_polish = polishlabels.slice(e.minValue, e.maxValue);
        const { renderGetDiamond } = this.props;

        this.setState({
            polishminvalue: e.minValue,
            polishmaxvalue: e.maxValue
        });

        const query = generateQuery({ diamond_polish: `${diamond_polish}` }, window.location, history);
        history.push(query);
        renderGetDiamond();
    }

    renderPolish() {
        const { polishlabels, polishmaxvalue, polishminvalue } = this.state;
        const { isMobile } = this.props;

        return (
            <>
                <div className='advace-options-swatchlist'>
                    {
                        isMobile ? <></> : <div
                            className='advanceoption-swatchlist-heading'
                            onClick={() => this.setState({
                                showoptions: this.state.attribute_code === "polish" ? !this.state.showoptions : true,
                                attribute_code: "polish"
                            })}
                        >
                            <span>Polish</span>
                            <img
                                className={this.state.attribute_code === "polish" && this.state.showoptions ? "open" : ""}
                                src={arrowdown}
                            />
                        </div>
                    }

                    {
                        (this.state.attribute_code === "polish" && this.state.showoptions) || isMobile ? <div className='advaceoptions-exapndable-options'>
                            <div className={"filteroption-title"}>
                                <span>Polish</span>
                                {!isMobile && <svg onClick={() => this.setState({
                                    showoptions: this.state.attribute_code === "polish" ? !this.state.showoptions : true,
                                    attribute_code: "polish"
                                })}
                                    xmlns="http://www.w3.org/2000/svg" height="16" width="12" viewBox="0 0 384 512" fill="#000000">
                                    <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                                </svg>}
                            </div>
                            <RangeSlider
                                label={true}
                                min={0}
                                max={3}
                                step={1}
                                labels={polishlabels}
                                minValue={polishminvalue}
                                maxValue={polishmaxvalue}
                                className={"colorrangeslider"}
                                onChange={(e) => this.handleChangePolishOptions(e)}
                            />
                        </div> : ""
                    }
                </div>

            </>
        );
    }

    // symmetry filter
    handleChangeSymmetryOptions(e) {
        const { symmetrylabels } = this.state;
        const diamond_symmetry = symmetrylabels.slice(e.minValue, e.maxValue);
        const { renderGetDiamond } = this.props;

        this.setState({
            symmetryminvalue: e.minValue,
            symmetrymaxvalue: e.maxValue
        });

        const query = generateQuery({ diamond_symmetry: `${diamond_symmetry}` }, window.location, history);
        history.push(query);
        renderGetDiamond();
    }

    renderSymmetry() {
        const { symmetrylabels, symmetrymaxvalue, symmetryminvalue } = this.state;
        const { isMobile } = this.props;

        return (
            <>
                <div className='advace-options-swatchlist'>
                    {
                        isMobile ? <></> : <div
                            className='advanceoption-swatchlist-heading'
                            onClick={() => this.setState({
                                showoptions: this.state.attribute_code === "symmetry" ? !this.state.showoptions : true,
                                attribute_code: "symmetry"
                            })}
                        >
                            <span>Symmetry</span>
                            <img
                                className={this.state.attribute_code === "symmetry" && this.state.showoptions ? "open" : ""}
                                src={arrowdown}
                            />
                        </div>
                    }
                    {
                        (this.state.attribute_code === "symmetry" && this.state.showoptions) || isMobile ? <div className='advaceoptions-exapndable-options'>
                            <div className={"filteroption-title"}>
                                <span>Symmetry</span>
                                {!isMobile && <svg onClick={() => this.setState({
                                    showoptions: this.state.attribute_code === "symmetry" ? !this.state.showoptions : true,
                                    attribute_code: "symmetry"
                                })}
                                    xmlns="http://www.w3.org/2000/svg" height="16" width="12" viewBox="0 0 384 512" fill="#000000">
                                    <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                                </svg>}
                            </div>
                            <RangeSlider
                                label={true}
                                min={0}
                                max={3}
                                step={1}
                                labels={symmetrylabels}
                                minValue={symmetryminvalue}
                                maxValue={symmetrymaxvalue}
                                className={"colorrangeslider"}
                                onChange={(e) => this.handleChangeSymmetryOptions(e)}
                            />
                        </div> : ""
                    }
                </div>
            </>
        );
    }

    // Fluorescence filter
    handleChangeFluorescenceOptions(e) {
        const { fluorescencelabels } = this.state;
        const diamond_fluorescence = fluorescencelabels.slice(e.minValue, e.maxValue);
        const { renderGetDiamond } = this.props;

        this.setState({
            fluorescenceminvalue: e.minValue,
            fluorescencemaxvalue: e.maxValue
        });

        const query = generateQuery({ diamond_fluorescence: `${diamond_fluorescence}` }, window.location, history);
        history.push(query);
        renderGetDiamond();
    }

    renderFluorescence(attributevalue, option) {
        const { fluorescencelabels, fluorescenceminvalue, fluorescencemaxvalue } = this.state;
        const { isMobile } = this.props;

        return (
            <>
                <div className='advace-options-swatchlist'>
                    {
                        isMobile ? <></> : <div
                            className='advanceoption-swatchlist-heading'
                            onClick={() => this.setState({
                                showoptions: this.state.attribute_code === "fluorescence" ? !this.state.showoptions : true,
                                attribute_code: "fluorescence"
                            })}
                        >
                            <span>Fluorescence</span>
                            <img
                                className={this.state.attribute_code === "fluorescence" && this.state.showoptions ? "open" : ""}
                                src={arrowdown}
                            />
                        </div>
                    }
                    {
                        (this.state.attribute_code === "fluorescence" && this.state.showoptions) || isMobile ? <div className='advaceoptions-exapndable-options'>
                            <div className={"filteroption-title"}>
                                <span>Fluorescence</span>
                                {!isMobile && <svg onClick={() => this.setState({
                                    showoptions: this.state.attribute_code === "fluorescence" ? !this.state.showoptions : true,
                                    attribute_code: "fluorescence"
                                })}
                                    xmlns="http://www.w3.org/2000/svg" height="16" width="12" viewBox="0 0 384 512" fill="#000000">
                                    <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                                </svg>}
                            </div>
                            <RangeSlider
                                label={true}
                                min={0}
                                max={4}
                                step={1}
                                labels={fluorescencelabels}
                                minValue={fluorescenceminvalue}
                                maxValue={fluorescencemaxvalue}
                                className={"colorrangeslider"}
                                onChange={(e) => this.handleChangeFluorescenceOptions(e)}
                            />
                        </div> : ""
                    }
                </div>

            </>
        );
    }

    //  depth filter
    cahngeDepthminValue = (e) => {
        this.setState({
            depthminvalue: e.target.value,
            changevalue: true
        });
    }

    cahngeDepthmaxValue = (e) => {
        this.setState({
            depthmaxvalue: e.target.value,
            changevalue: true
        });
    }

    enterDepthminValue = (e) => {
        const { depthminvalue, depthmaxvalue } = this.state;
        let query = "";
        const { renderGetDiamond } = this.props;

        if (e.code === "Enter" || e.keyCode === 13) {
            if (depthminvalue > 100) {
                this.setState({
                    depthminvalue: 100,
                    depthFilterminvalue: 100
                });
                query = `100_${depthmaxvalue}`;
            } else if (depthminvalue < 0) {
                this.setState({
                    depthminvalue: 0,
                    depthFilterminvalue: 0
                });
                query = `0_${depthmaxvalue}`;
            } else if (depthmaxvalue < depthminvalue) {
                this.setState({
                    depthminvalue: depthmaxvalue,
                    depthFilterminvalue: depthmaxvalue
                });
                query = `${depthmaxvalue}_${depthmaxvalue}`;
            } else {
                if (isNaN(depthminvalue)) {
                    this.setState({
                        depthminvalue: 0,
                        depthFilterminvalue: 0
                    });
                    query = `0_${depthmaxvalue}`;
                } else {
                    this.setState({
                        depthminvalue: depthminvalue,
                        depthFilterminvalue: depthminvalue
                    });
                    query = `${depthminvalue}_${depthmaxvalue}`;
                }
            }

            this.setState({
                changevalue: false
            });

            history.push(generateQuery({ depth: `${query}` }, window.location, history));
            renderGetDiamond();
        }
    }

    enterDepthmaxValue = (e) => {
        const { depthminvalue, depthmaxvalue, } = this.state;
        let query = "";
        const { renderGetDiamond } = this.props;

        if (e.code === "Enter" || e.keyCode === 13) {
            if (depthmaxvalue > 100) {
                this.setState({
                    depthmaxvalue: 100,
                    depthFiltermaxvalue: 100
                })
                query = `${depthminvalue}_100`;
            } else if (depthmaxvalue < 0) {
                this.setState({
                    depthmaxvalue: 0,
                    depthFiltermaxvalue: 0
                })
                query = `${depthminvalue}_0`;
            } else if (depthmaxvalue < depthminvalue) {
                this.setState({
                    depthmaxvalue: depthminvalue,
                    depthFiltermaxvalue: depthminvalue
                });
                query = `${depthminvalue}_${depthminvalue}`;
            } else {
                if (isNaN(depthmaxvalue)) {
                    this.setState({
                        depthmaxvalue: 100,
                        depthFiltermaxvalue: 100
                    });
                    query = `${depthminvalue}_100`;
                } else {
                    this.setState({
                        depthmaxvalue: depthmaxvalue,
                        depthFiltermaxvalue: depthmaxvalue
                    });
                    query = `${depthminvalue}_${depthmaxvalue}`;
                }
            }

            this.setState({
                changevalue: false
            });

            history.push(generateQuery({ depth: `${query}` }, window.location, history));
            renderGetDiamond();
        }
    }

    onDepthInput(e) {
        if (this.state.changevalue === false) {
            this.setState({
                depthFilterminvalue: e.minValue,
                depthFiltermaxvalue: e.maxValue,
                depthmaxvalue: e.maxValue,
                depthminvalue: e.minValue
            })
        }
    }

    handleChangeDepthOptions = (e) => {
        const { renderGetDiamond } = this.props;

        if (this.state.changevalue === false) {
            this.setState({
                depthFilterminvalue: e.minValue,
                depthFiltermaxvalue: e.maxValue,
                depthmaxvalue: e.maxValue,
                depthminvalue: e.minValue
            })
        }

        history.push(generateQuery({ depth: `${e.minValue}_${e.maxValue}` }, window.location, history));
        renderGetDiamond();
    }

    renderDepth() {
        const { isMobile } = this.props;

        return (
            <div className='advace-options-swatchlist'>
                {
                    isMobile ? <></> : <div
                        className='advanceoption-swatchlist-heading'
                        onClick={() => this.setState({
                            showoptions: this.state.attribute_code === "depth" ? !this.state.showoptions : true,
                            attribute_code: "depth"
                        })}
                    >
                        <span>Depth</span>
                        <img
                            className={this.state.attribute_code === "depth" && this.state.showoptions ? "open" : ""}
                            src={arrowdown}
                        />
                    </div>
                }
                {
                    (this.state.attribute_code === "depth" && this.state.showoptions) || isMobile ? <div className='advaceoptions-exapndable-options depth'>
                        <div className={"filteroption-title"}>
                            <span>Depth</span>
                            {!isMobile && <svg onClick={() => this.setState({
                                showoptions: this.state.attribute_code === "depth" ? !this.state.showoptions : true,
                                attribute_code: "depth"
                            })}
                                xmlns="http://www.w3.org/2000/svg" height="16" width="12" viewBox="0 0 384 512" fill="#000000">
                                <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                            </svg>}
                        </div>
                        <RangeSlider
                            label={false}
                            min={0}
                            max={100}
                            step={1}
                            minValue={this.state.depthFilterminvalue}
                            maxValue={this.state.depthFiltermaxvalue}
                            className={"caratrangeslider"}
                            oninput={(e) => this.onDepthInput(e)}
                            onChange={(e) => this.handleChangeDepthOptions(e)}
                        />
                        <div className='carat-input-value'>
                            <input
                                className='caratvalue'
                                type='text'
                                value={this.state.depthminvalue}
                                onChange={this.cahngeDepthminValue}
                                onKeyDown={this.enterDepthminValue}
                                name='minvalue'
                            />
                            <input
                                className='caratvalue'
                                type='text'
                                value={this.state.depthmaxvalue}
                                onChange={this.cahngeDepthmaxValue}
                                onKeyDown={this.enterDepthmaxValue}
                                name='maxvalue'
                            />
                        </div>
                    </div> : ""
                }
            </div>
        )
    }

    // tablefilter
    cahngetableminValue = (e) => {
        this.setState({
            tableminvalue: e.target.value,
            changetablevalue: true
        });
    }

    cahngetablemaxValue = (e) => {
        this.setState({
            tablemaxvalue: e.target.value,
            changetablevalue: true,
        });
    }

    enterTableminValue = (e) => {
        const { tableminvalue, tablemaxvalue } = this.state;
        let query = "";
        const { renderGetDiamond } = this.props;

        if (e.code === "Enter" || e.keyCode === 13) {
            if (tableminvalue > 100) {
                this.setState({
                    tableminvalue: 100,
                    tableFilterminvalue: 100
                });
                query = `100_${tablemaxvalue}`;
            } else if (tableminvalue < 0) {
                this.setState({
                    tableminvalue: 0,
                    tableFilterminvalue: 0
                });
                query = `0_${tablemaxvalue}`;
            } else if (tablemaxvalue < tableminvalue) {
                this.setState({
                    tableminvalue: tablemaxvalue,
                    tableFilterminvalue: tablemaxvalue
                });
                query = `${tablemaxvalue}_${tablemaxvalue}`;
            } else {
                if (isNaN(tableminvalue)) {
                    this.setState({
                        tableminvalue: 0,
                        tableFilterminvalue: 0
                    });
                    query = `0_${tablemaxvalue}`;
                } else {
                    this.setState({
                        tableminvalue: tableminvalue,
                        tableFilterminvalue: tableminvalue
                    });
                    query = `${tableminvalue}_${tablemaxvalue}`;
                }
            }

            this.setState({
                changetablevalue: false
            });

            history.push(generateQuery({ table: `${query}` }, window.location, history));
            renderGetDiamond();
        }
    }

    enterTablemaxValue = (e) => {
        const { tableminvalue, tablemaxvalue, } = this.state;
        let query = "";
        const { renderGetDiamond } = this.props;

        if (e.code === "Enter" || e.keyCode === 13) {
            if (tablemaxvalue > 100) {
                this.setState({
                    tablemaxvalue: 100,
                    tableFiltermaxvalue: 100
                })
                query = `${tableminvalue}_100`;
            } else if (tablemaxvalue < 0) {
                this.setState({
                    tablemaxvalue: 0,
                    tableFiltermaxvalue: 0
                })
                query = `${tableminvalue}_0`;
            } else if (tablemaxvalue < tableminvalue) {
                this.setState({
                    tablemaxvalue: tableminvalue,
                    tableFiltermaxvalue: tableminvalue
                });
                query = `${tableminvalue}_${tableminvalue}`;
            } else {
                if (isNaN(tablemaxvalue)) {
                    this.setState({
                        tablemaxvalue: 100,
                        tableFiltermaxvalue: 100
                    });
                    query = `${tableminvalue}_100`;
                } else {
                    this.setState({
                        tablemaxvalue: tablemaxvalue,
                        tableFiltermaxvalue: tablemaxvalue
                    });
                    query = `${tableminvalue}_${tablemaxvalue}`;
                }
            }

            this.setState({
                changetablevalue: false
            });

            history.push(generateQuery({ table: `${query}` }, window.location, history));
            renderGetDiamond();
        }
    }

    onTableInput(e) {
        if (this.state.changetablevalue === false) {
            this.setState({
                tableFilterminvalue: e.minValue,
                tableFiltermaxvalue: e.maxValue,
                tablemaxvalue: e.maxValue,
                tableminvalue: e.minValue
            })
        }
    }

    handleChangetableOptions = (e) => {
        const { renderGetDiamond } = this.props;

        if (this.state.changetablevalue === false) {
            this.setState({
                tableFilterminvalue: e.minValue,
                tableFiltermaxvalue: e.maxValue,
                tablemaxvalue: e.maxValue,
                tableminvalue: e.minValue
            })
        }

        history.push(generateQuery({ table: `${e.minValue}_${e.maxValue}` }, window.location, history));
        renderGetDiamond();
    }

    renderTable() {
        const { isMobile } = this.props;

        return (
            <div className='advace-options-swatchlist'>
                {
                    isMobile ? <></> : <div
                        className='advanceoption-swatchlist-heading'
                        onClick={() => this.setState({
                            showoptions: this.state.attribute_code === "table" ? !this.state.showoptions : true,
                            attribute_code: "table"
                        })}
                    >
                        <span>Table</span>
                        <img
                            className={this.state.attribute_code === "table" && this.state.showoptions ? "open" : ""}
                            src={arrowdown}
                        />
                    </div>
                }

                {
                    (this.state.attribute_code === "table" && this.state.showoptions) || isMobile ? <div className='advaceoptions-exapndable-options table'>
                        <div className={"filteroption-title"}>
                            <span>Table</span>
                            {!isMobile && <svg onClick={() => this.setState({
                                showoptions: this.state.attribute_code === "table" ? !this.state.showoptions : true,
                                attribute_code: "table"
                            })}
                                xmlns="http://www.w3.org/2000/svg" height="16" width="12" viewBox="0 0 384 512" fill="#000000">
                                <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                            </svg>}
                        </div>
                        <RangeSlider
                            label={false}
                            min={0}
                            max={100}
                            step={1}
                            minValue={this.state.tableFilterminvalue}
                            maxValue={this.state.tableFiltermaxvalue}
                            className={"caratrangeslider"}
                            oninput={(e) => this.onTableInput(e)}
                            onChange={(e) => this.handleChangetableOptions(e)}
                        />
                        <div className='carat-input-value'>
                            <input
                                className='caratvalue'
                                type='text'
                                value={this.state.tableminvalue}
                                onChange={this.cahngetableminValue}
                                onKeyDown={this.enterTableminValue}
                                name='minvalue'
                            />
                            <input
                                className='caratvalue'
                                type='text'
                                value={this.state.tablemaxvalue}
                                onChange={this.cahngetablemaxValue}
                                onKeyDown={this.enterTablemaxValue}
                                name='maxvalue'
                            />
                        </div>
                    </div> : ""
                }
            </div>
        )
    }

    // change diamond option natral/lab grown
    renderDiamondCreatedFrom(value) {
        const { renderGetDiamond } = this.props;
        this.setState({
            diamond_created_from: value
        });

        history.push(generateQuery({ diamond_created_from: `${value}` }, window.location, history));
        renderGetDiamond();
    }

    selectDiamondOrigin = (url) => {
        const { location } = history;

        const searhprms = getQueryParam("diamond_created_from", location || '');
        const updatedqueryPramas = location?.search?.replace(`?diamond_created_from=${searhprms}`, "");

        history.push(`${url}${updatedqueryPramas}`);
    }

    render() {
        const { isMobile } = this.props;
        const { location } = history;

        const searhprms = getQueryParam("diamond_created_from", location || '');
        const updatedqueryPramas = location?.search?.replace(`?diamond_created_from=${searhprms}`, "");

        return (
            <div className="AdvaceOtions">
                <div className='advaceoptions-heading'>
                    <div
                        className={"advanced-filter-btn"}
                        onClick={this.renderHandleOpen}
                    >
                        <span>{isMobile ? this.state.advanceoption_open ? "Hide " : "Show " : ""}Advanced Filters</span>
                        <img className={this.state.advanceoption_open ? "open" : ""} src={arrowdown} />
                    </div>
                    <div className='diamonds-options'>
                        {/* <Link
                            onClick={this.selectDiamondOrigin}
                        // to={`/customize/ring-diamond/natural-diamond.html?diamond_created_from=11${updatedqueryPramas}`}
                        > */}
                        <button
                            onClick={() => this.selectDiamondOrigin('/customize/ring-diamond/natural-diamond.html?diamond_created_from=11')}
                            className={this.state.diamond_created_from === "11" ? 'diamonds-options_active' : 'diamonds-option'}
                        >
                            <span>Natural</span>
                        </button>
                        {/* </Link> */}
                        {/* <Link
                            to={`customize/ring-diamond/lab-grown-diamond.html?diamond_created_from=12${updatedqueryPramas}`}
                        > */}
                        <button
                            onClick={() => this.selectDiamondOrigin('/customize/ring-diamond/lab-grown-diamond.html?diamond_created_from=12')}
                            className={this.state.diamond_created_from === "12" ? 'diamonds-options_active' : 'diamonds-option'}
                        >
                            <span>Lab Grown</span>
                        </button>
                        {/* </Link> */}
                    </div>
                </div>
                {
                    this.state.advanceoption_open ?
                        <div className='advaceoptions-container'>
                            {this.renderCut()}
                            {this.renderPolish()}
                            {this.renderSymmetry()}
                            {this.renderFluorescence()}
                            {this.renderDepth()}
                            {this.renderTable()}
                        </div> : ""
                }
            </div>
        );
    }
}

export default AdvaceOtions;
